
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Action, Getter, namespace, State } from 's-vuex-class'
import { IFilterOption, IFilter } from '../entities/filter'
import Dropdown from './Dropdown.vue'
import FilterModalMobileHeader from '@/components/FilterModalMobileHeader.vue'
import { IScorecardSetting } from '@/pages/appstore/components/Scorecard/scorecard-settings-entity'
const ScorecardSettingsModule = namespace('scorecardSettings')

@Component<FilterBarActive>({
    components: { FilterModalMobileHeader, Dropdown },
})
export default class FilterBarActive extends Vue {
    @Getter public filterActive?: IFilter
    @Getter public filterRuleOptions?: {
        general: IFilterOption[]
        custom: IFilterOption[]
    }

    @Action public removeAllFilters
    @Action public removeFilterValue
    @Action public removeFilterRule
    @Action public setFilterEditing
    @Getter public tsMobileView
    @Getter public scorecardTopics

    @ScorecardSettingsModule.Getter
    readonly scorecardList!: IScorecardSetting[]

    @ScorecardSettingsModule.Action
    loadScorecardList

    public operatorSymbols: object = {
        gt: '> ',
        lt: '< ',
        in: '',
        notin: '≠ ',
    }

    public get rules() {
        const filterActive = this.filterActive
        return filterActive && filterActive.filter_rules
            ? filterActive.filter_rules.filter(
                  (rule) =>
                      !rule.value.find((v) => v === 'any') &&
                      rule.column !== 'question_type'
              )
            : []
    }

    public async mounted() {
        if (!this.scorecardList.length) {
            await this.loadScorecardList()
        }
    }

    public formatLabel(
        scorecardField: string,
        value: string[],
        operator: string
    ) {
        return (
            this.operatorSymbols[operator] +
            value
                .map((v) => v.replace(/_c$/g, '').replace(/_/g, ' '))
                .map((v) =>
                    this.scorecardList.find(
                        (scorecardTopic) =>
                            scorecardTopic.field === scorecardField
                    ) &&
                    this.scorecardTopics.find(
                        (scorecardTopic) => scorecardTopic.id === parseInt(v)
                    )
                        ? this.scorecardTopics.find(
                              (scorecardTopic) =>
                                  scorecardTopic.id === parseInt(v)
                          ).topic_name
                        : v
                )
                .join(', ')
        )
    }

    public formatColumn(column: string) {
        const options = this.filterRuleOptions
        const option =
            options &&
            options.general
                .concat(options.custom)
                .find((f: IFilterOption) => f.value === column)
        return ((option && option.label) || column)
            .replace(/_c$/g, '')
            .replace(/_/g, ' ')
    }

    public initSaveFilter() {
        const active = this.filterActive
        if (active) {
            this.setFilterEditing({ id: active.id, mode: 'create' })
        }
    }

    private closeModal() {
        (this.$refs.dropdown as any).$data.opened = false
    }
}
